<template>
  <div :class="styles['auth-layout']">
    <div :class="styles['auth-layout__banner-wrapper']">
      <AuthAiPreview :class="styles['auth-layout__banner']" />
    </div>
    <div :class="styles['auth-layout__content-wrapper']">
      <div
        :class="[
          styles['auth-layout__logo-wrapper'],
          {
            [styles['auth-layout__logo-wrapper--top']]: isLogoTop
          }
        ]"
      >
        <CompanyLogo
          v-if="hasCompany"
        />
      </div>
      <router-view />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, provide, useCssModule } from "vue"
import AuthAiPreview from '@/components/features/AuthAiPreview.vue'
import CompanyLogo from '@/components/features/CompanyLogo.vue'
import { useRoute } from "vue-router"

const route = useRoute()

const hasCompany = computed(() => {
  const { company } = route.params

  return company && !['undefined', 'null'].includes(company as string)
})

const isLogoTop = computed(() => {
  return [
    'create-account',
    'company-create-account',
  ].includes(route.name as string)
})

provide('hasCompany', hasCompany.value)

const styles = useCssModule()
</script>

<style lang="scss" module>
$auth-bg: #f3f1ea;

.auth-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;
  // White base so the translucent right-hand tint reads as a lighter shade of
  // the banner colour; --v-app-bg is the same beige and would cancel it out.
  background-color: #fff;

  @include media-breakpoint-down(md) {
    grid-template-columns: 1fr;
  }
}

.auth-layout__banner-wrapper {
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  background-color: $auth-bg;
  @include media-breakpoint-down(md) {
    display: none;
  }
}

.auth-layout__content-wrapper {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: rgba($auth-bg, .2);
  filter: var(--v-primary-shadow);
  @include media-breakpoint-down(sm) {
    padding: 10px;
  }
}
.auth-layout__logo-wrapper {
  position: absolute;
  max-width: 250px;
  width: 100%;
  height: auto;
  left: 50%;
  top: 40px;
  transform: translateX(-50%);

  svg {
    width: 100%;
    height: auto;
  }

  @include media-breakpoint-down(sm) {
    top: 20px;
    max-width: 200px;
  }
}
.auth-layout__logo-wrapper--top {
  top: 20px;
}

.auth-layout__banner {
  z-index: 1;
  display: flex;
  flex-direction: column;
}
</style>
